module.exports = __webpack_public_path__ + "static/media/Panpour_gaussian2.5ee19796.png";